import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import styles from "./ObraL1.module.css";

function ObraL1({ distrito }) {
  const [nascentes, setNascentes] = useState(null);
  const [aguaCorrente, setAguaCorrente] = useState(null);
  const [mata, setMata] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [nascentes, aguaCorrente, mata] = await Promise.all(
          [
            Api.getNascentes(distrito),
            Api.getAguaCorrente(distrito),
            Api.getMata(distrito),
          ]
        );
        setNascentes(Functions.buildSmallPieGraphParams(nascentes));
        setAguaCorrente(Functions.buildSmallPieGraphParams(aguaCorrente));
        setMata(Functions.buildSmallPieGraphParams(mata));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };
  return (
    <div className={styles.obraL1}>
      <div className={styles.smallPiegraph}>
        {nascentes && (
          <SmallPieGraph
            data={nascentes}
            text="GERÊNCIA DA PROPRIEDADE"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {aguaCorrente && (
          <SmallPieGraph
            data={aguaCorrente}
            text="MÃO DE OBRA"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>

      <div className={styles.smallPiegraph}>
        {mata && (
          <SmallPieGraph
            data={mata}
            text="PARTICIPA DE ORGANIZAÇÃO"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
        )}
      </div>
    </div>
  );
}

export default ObraL1;
